export default __webpack_public_path__ + "static/media/Me.0d1c00da.png";